import { render } from "./FieldSettings.vue?vue&type=template&id=90ed7b84"
import script from "./FieldSettings.vue?vue&type=script&lang=js"
export * from "./FieldSettings.vue?vue&type=script&lang=js"

import "./FieldSettings.vue?vue&type=style&index=0&id=90ed7b84&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__